import {Page} from 'utils/page-utils';
import CMSUtils, {CustomTypes} from 'utils/cms';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';

const getInitialState = async ({state}) => ({
    ...state,
    searchRequest: {
        ...searchRequestInitialState,
        pageType: Page.HOME,
    },
    page: await CMSUtils.getPageData({
        customType: CustomTypes.HOME_PAGE,
        slug: '',
        pageType: Page.HOME,
    }),
});

export default getInitialState;
